import { createRequestTypes } from 'common/websocket-redux';

export const FETCH_CLAIMS = createRequestTypes('claims/FETCH_CLAIMS');
export const FETCH_AGENTS = createRequestTypes('claims/FETCH_AGENTS');
export const ON_PAGE_NUMBER_SELECTED = 'claims/PAGE_NUMBER_SELECTED';
export const ON_SORT_ORDER_CHANGED = 'claims/SORT_ORDER_CHANGED';
export const ON_FILTER_CHANGED = 'claims/FILTER_CHANGED';
